import * as React from "react";
import { type MenuTab2Item, MenuTabs2 } from "src/components/MenuTabs2";
import { PageLayout } from "src/components/PageLayout";
import { PageUrl } from "src/routes/PageUrl";

import * as styles from "./ObjectsManager.module.less";

type ObjectManagerTab =
  | "catalogs"
  | "classifiers"
  | "primSpecs"
  | "secondSpecs"
  | "valueCatalogs"
  | "valueSpecs";

const tabs: Record<ObjectManagerTab, MenuTab2Item> = {
  catalogs: { label: "Каталоги", page: PageUrl.managementCatalogs },
  classifiers: { label: "Классификаторы", page: PageUrl.managementClassifiers },
  valueCatalogs: {
    label: "Каталоги значений",
    page: PageUrl.managementValueCatalogs,
  },
  primSpecs: {
    label: "Первичные спецификации",
    page: PageUrl.managementPrimSpecs,
  },
  secondSpecs: {
    label: "Вторичные спецификации",
    page: PageUrl.managementSecondSpecs,
  },
  valueSpecs: {
    label: "Спецификации значений",
    page: PageUrl.managementValueSpecs,
  },
};

type PropsObjectsManager = {
  tab: ObjectManagerTab;
  children: React.ReactNode;
};
export const ObjectsManager: React.FC<PropsObjectsManager> = ({
  tab,
  children,
}) => (
  <PageLayout title="Объекты и спецификации">
    <div className={styles.box}>
      <MenuTabs2 activeTab={tab} tabs={tabs} />
      <div className={styles.content}>{children}</div>
    </div>
  </PageLayout>
);
